var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-divider', {
    staticClass: "custom-divider"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.uploadSetting')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.uploadURL')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.optionModel.uploadURL),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "uploadURL", $$v)
      },
      expression: "optionModel.uploadURL"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-158231f4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/uploadURL-editor.vue
// module id = null
// module chunks = 